import { render, staticRenderFns } from "./jt-record.vue?vue&type=template&id=06e2cd85&scoped=true&"
import script from "./jt-record.vue?vue&type=script&lang=js&"
export * from "./jt-record.vue?vue&type=script&lang=js&"
import style0 from "./jt-record.vue?vue&type=style&index=0&id=06e2cd85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e2cd85",
  null
  
)

export default component.exports